export interface IFsLprProvidersInterface {
  code: string;
  name: string;
}
